import validateEmail from "../../helpers/ValidateEmail";

(function () {
    if (document.querySelectorAll(".js-cision-financial").length > 0) {

        const cisionFormFinancial = {
            store: {
                errorCount: 0
            },
            init: function () {
                this.checkQueryString();
                this.validateForm();
            },
            checkQueryString: () => {
                const successMessageBox = document.getElementById("result__success");
                const urlParams = new URLSearchParams(window.location.search);
                const success = urlParams.get("successfulSubmit");
                const error = urlParams.get("ERROR");

                if (success !== null) {
                    if (success == "true") {
                        successMessageBox.classList.add("success");
                    } else {
                        if (error == "RECAPTCHA_INVALID") {
                            successMessageBox.classList.add("fail");
                        } else {
                            successMessageBox.classList.add("fail");
                        }
                    }
                }
            },
            validateForm: () => {
                const submitFormButton = document.getElementById(
                    "cision__financial--submit"
                );

                submitFormButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    cisionFormFinancial.store.errorCount = 0;
                    cisionFormFinancial.validateEmail();
                    cisionFormFinancial.validateLanguage();
                    cisionFormFinancial.validatePublication();
                    cisionFormFinancial.submitForm();
                });
            },
            validateLanguage: () => {
                const languageFieldset = document.getElementById(
                    "cision__financial--language"
                );

                const selectedLanguages = languageFieldset.querySelectorAll(
                    "input[type='checkbox']:checked"
                );

                if (selectedLanguages.length === 0) {
                    languageFieldset.classList.add("form__error");
                    cisionFormFinancial.store.errorCount++;
                } else {
                    languageFieldset.classList.remove("form__error");
                }
            },
            validatePublication: () => {
                const publicationFieldset = document.getElementById(
                    "cision__financial--publication"
                );

                const selectedPublications = publicationFieldset.querySelectorAll(
                    "input[type='checkbox']:checked"
                );

                if (selectedPublications.length === 0) {
                    publicationFieldset.classList.add("form__error");
                    cisionFormFinancial.store.errorCount++;
                } else {
                    publicationFieldset.classList.remove("form__error");
                }
            },
            validateEmail: () => {
                const emailInput = document.getElementById("email");
                const isValid = validateEmail(emailInput.value);

                if (!isValid) {
                    emailInput.parentElement.classList.add("form__error");
                    cisionFormFinancial.store.errorCount++;
                } else {
                    emailInput.parentElement.classList.remove("form__error");
                }
            },
            submitForm: () => {
                if (cisionFormFinancial.store.errorCount === 0) {
                    const formElement = document.getElementById("cision__financial");

                    formElement.submit();
                }
            },
        };

        cisionFormFinancial.init();
    }
})();
